import { actions } from './actions'

const initialState = {
  bibliotecaPlantilla: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecasPlantilla: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecasPlantillaByProducto: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function bibPlantillaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.BIBPLANTILLA_FILTERED_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasPlantilla: { ...state.bibliotecasPlantilla, data: null, loading: true },
      }
    case actions.BIBPLANTILLA_FILTERED_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasPlantilla: {
          ...state.bibliotecasPlantilla,
          data: action.payload,
          loading: false,
        },
      }
    case actions.BIBPLANTILLA_FILTERED_LOAD_FAILED:
      return {
        ...state,
        bibliotecasPlantilla: {
          ...state.bibliotecasPlantilla,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBPLANTILLA_FILTERED_WITH_FILES_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasPlantilla: { ...state.bibliotecasPlantilla, data: null, loading: true },
      }
    case actions.BIBPLANTILLA_FILTERED_WITH_FILES_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasPlantilla: {
          ...state.bibliotecasPlantilla,
          data: action.payload,
          loading: false,
        },
      }
    case actions.BIBPLANTILLA_FILTERED_WITH_FILES_LOAD_FAILED:
      return {
        ...state,
        bibliotecasPlantilla: {
          ...state.bibliotecasPlantilla,
          loading: false,
          error: action.error,
        },
      }
    case actions.DELETE_BIBPLANTILLA_REQUESTED:
      return {
        ...state,
        bibliotecasPlantilla: { ...state.bibliotecasPlantilla, loading: true },
      }
    case actions.DELETE_BIBPLANTILLA_SUCCEEDED: {
      return {
        ...state,
        bibliotecasPlantilla: {
          ...state.bibliotecasPlantilla,
          data: state.bibliotecasPlantilla.data.filter(d => action.payload !== d.id),
          loading: false,
          reload: false,
        },
      }
    }
    case actions.DELETE_BIBPLANTILLA_FAILED:
      return {
        ...state,
        bibliotecasPlantilla: {
          ...state.bibliotecasPlantilla,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBPLANTILLA_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecasPlantilla: { ...state.bibliotecasPlantilla, loading: true, error: '' },
        bibliotecaPlantilla: { ...state.bibliotecaPlantilla, loading: true, error: '' },
      }
    case actions.BIBPLANTILLA_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecasPlantilla: {
          data: [
            ...state.bibliotecasPlantilla.data.filter(b => b.id !== action.payload.id),
            action.payload,
          ],
          loading: false,
          error: '',
        },
        bibliotecaPlantilla: {
          ...state.bibliotecaPlantilla,
          data: action.payload,
          loading: false,
          error: '',
        },
      }
    case actions.BIBPLANTILLA_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaPlantilla: {
          ...state.bibliotecasPlantilla,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBPLANTILLA_INSERT_REQUESTED:
      return {
        ...state,
        bibliotecasPlantilla: { ...state.bibliotecasPlantilla, loading: true, error: '' },
      }
    case actions.BIBPLANTILLA_INSERT_SUCCEEDED:
      return {
        ...state,
        bibliotecasPlantilla: {
          data: [...state.bibliotecasPlantilla.data, action.payload],
          loading: false,
          error: '',
        },
      }
    case actions.BIBPLANTILLA_INSERT_FAILED:
      return {
        ...state,
        bibliotecasPlantilla: {
          ...state.bibliotecasPlantilla,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBPLANTILLA_BYID_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecaPlantilla: { ...state.bibliotecaPlantilla, loading: true, error: '' },
      }
    case actions.BIBPLANTILLA_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecaPlantilla: {
          data: action.payload,
          loading: false,
          error: '',
        },
      }
    case actions.BIBPLANTILLA_BYID_LOAD_FAILED:
      return {
        ...state,
        bibliotecaPlantilla: {
          ...state.bibliotecaPlantilla,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBSPLANTILLA_PRODUCTO_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecasPlantillaByProducto: {
          ...state.bibliotecasPlantillaByProducto,
          loading: true,
          error: '',
        },
      }
    case actions.BIBSPLANTILLA_PRODUCTO_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecasPlantillaByProducto: {
          ...state.bibliotecasPlantillaByProducto,
          data: [...action.payload],
          loading: false,
          error: '',
        },
      }
    case actions.BIBSPLANTILLA_PRODUCTO_UPDATE_FAILED:
      return {
        ...state,
        bibliotecasPlantillaByProducto: {
          ...state.bibliotecasPlantillaByProducto,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBPLANTILLA_BY_PRODUCTO_ID_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasPlantillaByProducto: {
          ...state.bibliotecasPlantillaByProducto,
          data: null,
          loading: true,
        },
      }
    case actions.BIBPLANTILLA_BY_PRODUCTO_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasPlantillaByProducto: {
          ...state.bibliotecasPlantillaByProducto,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBPLANTILLA_BY_PRODUCTO_ID_LOAD_FILED:
      return {
        ...state,
        bibliotecasPlantillaByProducto: {
          ...state.bibliotecasPlantillaByProducto,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
